<ng-content></ng-content>

<cm-inspector-section>
    <ng-container cm-title> Extract Material Slot </ng-container>
    <ng-container cm-content>
        <cm-value-slot [node]="$node()" [key]="'material'" [label]="'Material'"></cm-value-slot>
        <cm-value-slot [node]="$node()" [key]="'slot'" [label]="'Slot'" [selectionPossibilities]="$slotPossibilities()"></cm-value-slot>
    </ng-container>
</cm-inspector-section>
